import Message from "components/messages/Message";
import { useState, useEffect } from "react";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import { Helmet } from "react-helmet";
import sendRequest from "hooks/useAxios";
export default function CustomerMessage() {
  const [messages, setMessages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    sendRequest("Find_notifications").then(({ data }) => {
      setMessages(data);
    });
  }, []);
  // {
  //   time: 1046105640,
  //   description: "فقط تا 24 ساعت آینده فرصت  دارید که از تخفیف ویژه لپ تاپ های ما استفاده کنید",
  //   type: 2,
  // },
  return (
    <>
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>پیام ها</title>
        </Helmet>
      </div>
      <div className="d-flex align-items-baseline">
        <div className=" rounded-circle m-4 justify-content-center align-items-center d-flex" style={{ backgroundColor: "#ECA72C", width: "30px", height: "30px" }}>
          <svg xmlns="http://www.w3.org/2000/svg" className="" width="20" height="20" viewBox="0 0 24 29.25">
            <path id="Icon_material-notifications" data-name="Icon material-notifications" d="M18,33a3.009,3.009,0,0,0,3-3H15A3,3,0,0,0,18,33Zm9-9V16.5c0-4.6-2.46-8.46-6.75-9.48V6a2.25,2.25,0,0,0-4.5,0V7.02C11.445,8.04,9,11.88,9,16.5V24L6,27v1.5H30V27Z" transform="translate(-6 -3.75)" fill="#fff" />
          </svg>
        </div>
        <h5>پیام ها</h5>
      </div>

      {messages.slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5).map((value) => {
        return <Message type={+value.table_soucre_code} time={parseInt(value.mtm)} description={value.txt}></Message>;
      })}
      <div className="d-flex ">
        <Pagination
          className="mx-auto my-3"
          total={messages.length}
          pageSize={5}
          current={currentPage}
          onChange={(page) => {
            setCurrentPage(page);
          }}
        ></Pagination>
      </div>
    </>
  );
}
